import Vue from 'vue';
import { MutationTree } from 'vuex';
import { TeacherState } from './state';

const mutations: MutationTree<TeacherState> = {
  SET_TEACHERS(state, entities: TeacherState) {
    if (!entities.teachers) return;

    Object.values(entities.teachers).map((teacher) => {
      return Vue.set(state.teachers, teacher.id.toString(), {
        ...state.teachers[teacher.id],
        ...teacher,
      });
    });
  },
};

export default mutations;
